import React from 'react';
import * as ReactDOMClient from 'react-dom/client';
import { ApolloProvider } from '@apollo/client';
import './theme/fonts';
import TranslationProvider from './components/translation/TranslationProvidor';
import client from './apollo-client';
import App from './App';

const container = document.getElementById('root');
const root = ReactDOMClient.createRoot(container);

root.render(
  <React.StrictMode>
    <ApolloProvider client={client}>
      <TranslationProvider>
        <App />
      </TranslationProvider>
    </ApolloProvider>
  </React.StrictMode>,
);
